import { singleParamActionCreator } from '../../lib/singleParamActionCreator'

// Assign a value to the 'saved' flag of a debuglog
export const SET_LOG_ENTRY_FLAG = 'SET_LOG_ENTRY_FLAG'

export const setLogEntryFlag = singleParamActionCreator(SET_LOG_ENTRY_FLAG)
